<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Edit Asset User</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle> 
    <mat-card-content>
      <form
        [formGroup]="editAssetUserForm"
        (ngSubmit)="updateAssetUser()"
        novalidate
      >
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field color="accent">
              <mat-label>EmployeeId</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter EmployeeId Max(20) chars"
                name="employeeId"
                formControlName="employeeId"
                required
                maxlength="20"
              />
              <mat-error
                *ngIf="editAssetUserForm.get('employeeId').hasError('required')"
              >
                EmployeeId is required.
              </mat-error>
              <mat-error
                *ngIf="
                  editAssetUserForm.get('employeeId').hasError('maxlength')
                "
              >
                EmployeeId cannot be more than 20 characters.
              </mat-error>
              <mat-error
                *ngIf="editAssetUserForm.get('employeeId').hasError('pattern')"
              >
                EmployeeId must contain only letters and numbers, with no spaces
                in between.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field color="accent">
              <mat-label>First Name</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter First Name Max(20) chars"
                name="firstName"
                formControlName="firstName"
                required 
                maxlength="20"
              />
              <mat-error
                *ngIf="editAssetUserForm.get('firstName').hasError('required')"
              >
                First Name is required.
              </mat-error>
              <mat-error
                *ngIf="editAssetUserForm.get('firstName').hasError('maxlength')"
              >
                First Name cannot be more than 20 characters.
              </mat-error>
              <mat-error
                *ngIf="editAssetUserForm.get('firstName').hasError('pattern')"
              >
                First Name must only contain letters, spaces, and period.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field>
              <mat-label>Last Name</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter Last Name Max(20) chars"
                name="lastName"
                formControlName="lastName"
                maxlength="20"
                required
              />
              <mat-error
                *ngIf="editAssetUserForm.get('lastName').hasError('required')"
              >
                Last name is required.
              </mat-error>
              <mat-error
                *ngIf="editAssetUserForm.get('lastName').hasError('maxlength')"
              >
                Last name be more than 250 characters.
              </mat-error>
              <mat-error
                *ngIf="editAssetUserForm.get('lastName').hasError('pattern')"
              >
                Last Name must only contain letters, spaces, and period.
              </mat-error>
            </mat-form-field>
          </div>
           <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field>
              <mat-label>Email</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter Email Max(50) chars"
                name="email"
                formControlName="email"
                maxlength="50"
                required
              />
              <mat-error
                *ngIf="editAssetUserForm.get('email').hasError('required')"
              >
                Last name is required.
              </mat-error>
              <mat-error
                *ngIf="editAssetUserForm.get('email').hasError('maxlength')"
              >
                Email can not be be more than 250 characters.
              </mat-error>
              <mat-error
                *ngIf="editAssetUserForm.get('email').hasError('invalidEmail')"
              >
                {{ editAssetUserForm.get("email").getError("invalidEmail") }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6" *ngIf="userStatus != null">
            <mat-form-field color="accent">
              <mat-label>Select Status</mat-label>
              <mat-select
                formControlName="appStatusId"
                required
                placeholder="User status"
              >
                <mat-option [value]="null">Select a status</mat-option>
                <mat-option
                  *ngFor="let status of userStatus"
                  [value]="status.appStatusId"
                >
                  {{ status.status }}
                </mat-option>
              </mat-select>

              <mat-error
                *ngIf="
                  editAssetUserForm.get('appStatusId').hasError('required')
                "
              >
                Staus is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field>
              <mat-label>Mobile Number</mat-label>
              <input
                matInput
                type="text"
                placeholder="Mobile Number Max(10) digits"
                name="mobileNumber"
                formControlName="mobileNumber"
               maxlength="10"
                required
              />
              <mat-error
                *ngIf="
                  editAssetUserForm.get('mobileNumber').hasError('required')
                "
              >
                Mobile number is required.
              </mat-error>
              <mat-error
                *ngIf="
                  editAssetUserForm.get('mobileNumber').hasError('pattern')
                "
              >
                Mobile number can not be be more than 10 digits.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="col-md-6">
          <button
            md-raised-button
            type="button"
            class="btn btn-round btn-block btn-rose"
            (click)="close()"
          >
            Close
          </button>
        </div>
        <div class="col-md-6">
          <button
            md-raised-button
            type="button"
            class="btn btn-round btn-block btn-rose"
            (click)="updateAssetUser()"
            [disabled]="!editAssetUserForm.valid">
            Update
          </button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
